import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import { Member } from '../models/member';

type MemberMeInvoiceAddressProps = {
  member: Member;
};

const MemberMeInvoiceAddress = (props: MemberMeInvoiceAddressProps) => {
  const { member } = props;
  const { t } = useTranslation();

  return (
    <ContentSection header={t('member:invoiceAddress.pageHeader')}>
      <Grid container>
        <Grid item xs={12} sm={4} mb={{ xs: 2, sm: 0 }}>
          {!member.invoiceAddress && (
            <Typography variant='body1' sx={{ color: 'grey.500', py: 1 }}>
              {t('member:invoiceAddress.noInvoiceAddress')}
            </Typography>
          )}
          {member.invoiceAddress?.name && <Typography variant='body1'>{member.invoiceAddress.name}</Typography>}
          {member.invoiceAddress?.address && <Typography variant='body1'>{member.invoiceAddress.address}</Typography>}
          {member.invoiceAddress?.postalcode && member.invoiceAddress?.city && (
            <Typography variant='body1'>{`${member.invoiceAddress.postalcode} ${member.invoiceAddress.city}`}</Typography>
          )}
        </Grid>
        {member.invoiceAddress?.email && (
          <Grid item xs={12} sm={4} mb={{ xs: 2, sm: 0 }}>
            <Typography variant='body1' fontWeight={600}>
              {t('member:invoiceAddress.email')}:
            </Typography>
            <Typography variant='body1'>{member.invoiceAddress.email}</Typography>
          </Grid>
        )}
        {member.invoiceReference && (
          <Grid item xs={12} sm={4} mb={{ xs: 1, sm: 0 }}>
            <Typography variant='body1' fontWeight={600}>
              {t('member:invoiceAddress.reference')}:
            </Typography>
            <Typography variant='body1'>{member.invoiceReference}</Typography>
          </Grid>
        )}
      </Grid>
    </ContentSection>
  );
};

export default MemberMeInvoiceAddress;
